<template>
    <v-dialog v-model="showDialog" persistent max-width="70%">
        <v-card>
            <v-card-title>
                <div>
                    <h2 class="headline"> Configurações</h2>
                </div>
                <v-spacer></v-spacer>
                <v-btn fab small text @click="doHideDialog">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-card-title>
            <v-tabs v-model="tabs" grow>
                <v-tab :key="1">Projetos</v-tab>
                <v-tab :key="2">Clientes</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs">
                <v-tab-item>
                    <v-card-title>
                        <v-btn text @click="storeClientes.load()"><v-icon left>refresh</v-icon>Atualizar</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-tabs v-model="tabsProjetos" optional show-arrows>
                        <v-tab>Pessoal</v-tab>
                        <template v-for="item in storeClientes.data">
                            <v-tab>{{item.nome}}</v-tab>
                        </template>
                    </v-tabs>
                    <v-tabs-items v-model="tabsProjetos">
                        <v-tab-item>
                            <Projetos/>
                        </v-tab-item>
                        <template v-for="item in storeClientes.data">
                            <v-tab-item>
                                <Projetos v-bind:cliente="item.id"/>
                            </v-tab-item>
                        </template>
                    </v-tabs-items>
                </v-tab-item>
                <v-tab-item>
                    <Clientes/>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-dialog>
</template>

<script>

import Utils from '@/utils/Utils.js';
import { EventBus } from '@/EventBus.js';
import { Store } from '@/utils/Store.js';
import Projetos from '@/views/configuracoes/Projetos.vue'
import Clientes from '@/views/configuracoes/Clientes.vue'

export default {
    props: ['showDialog'],
    components: {
        Projetos,
        Clientes
    },
    methods: {
        doHideDialog() {
            EventBus.$emit('hideConfiguracoes');
        }
    },
    created() {
        this.storeClientes.load();
    },
    data() {
        return {
            storeClientes: new Store({
                url: '/clientes/Clientes'
            }),
            tabsProjetos: 0,
            tabs: 0,
            search: '',
            isTrue: true
        };
    }
}
</script>